import { useMutation } from "@tanstack/react-query";
import type { AxiosRequestConfig } from "axios";
import { headlessBrowserApi } from "./headless-browser.api";

export const useGeneratePdfMutation = () => {
  return useMutation({
    mutationKey: ["generate-pdf"],
    mutationFn: ({
      payload,
      config,
    }: {
      payload: unknown;
      config?: AxiosRequestConfig;
    }) => headlessBrowserApi.generatePdf(payload, config),
  });
};
